import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  ContainerRow,
  TableCardValue,
  ContainerAccordion,
  ContainerColumn,
  Icon,
  ContainerCardName,
  ContainerCardNameImage,
  CardName,
  Image,
} from './styles';

import TextRemaingCards from './text-remaining-cards';

const LIMIT_CARDS = 2;

const CardsList = (props) => {
  const {
    group,
  } = props;

  const [showRemaining, setShowRemaining] = useState(false);

  const mappedGroups = useMemo(() => {
    const orderedGroup = _.orderBy(group, ['frequencyPercentage'], ['desc']);
    const firstTwo = orderedGroup.slice(0, 2);
    const remainingGroups = (orderedGroup.length > LIMIT_CARDS) ? orderedGroup.slice(2) : [];
    const remainingLength = orderedGroup.length - LIMIT_CARDS;
    return ({
      firstTwo,
      remainingGroups,
      remaining: remainingLength,
    });
  }, [group]);

  return (
    <ContainerColumn>
      {_.map(mappedGroups.firstTwo, (card) => (
        <ContainerRow noBorder key={card.cardSortItem.id}>
          <ContainerCardName>
            <ContainerCardNameImage>
              <CardName>{card.cardSortItem.name}</CardName>
              {card.cardSortItem.imageUrl && (
                <Image
                  src={card.cardSortItem.imageUrl}
                  alt={card.cardSortItem.imageKey}
                />
              )}
            </ContainerCardNameImage>
          </ContainerCardName>
          <TableCardValue>
            {card.frequencyTotal}
            {` (${Math.round(card.frequencyPercentage * 100)}%)`}
          </TableCardValue>
        </ContainerRow>
      ))}

      {mappedGroups.remainingGroups.length > 0 && (
        <>
          <ContainerAccordion onClick={() => setShowRemaining(!showRemaining)}>
            <Icon name={showRemaining ? 'caret down' : 'caret right'} />
            <TextRemaingCards
              mappedGroups={mappedGroups}
              showRemaining={showRemaining}
            />
          </ContainerAccordion>

          {showRemaining && _.map(mappedGroups.remainingGroups, (cardRemaining) => (
            <ContainerRow noBorder key={cardRemaining.cardSortItem.id}>
              <ContainerCardName>
                <ContainerCardNameImage>
                  <CardName>{cardRemaining.cardSortItem.name}</CardName>
                  {cardRemaining.cardSortItem.imageUrl && (
                    <Image
                      src={cardRemaining.cardSortItem.imageUrl}
                      alt={cardRemaining.cardSortItem.imageKey}
                    />
                  )}
                </ContainerCardNameImage>
              </ContainerCardName>
              <TableCardValue>
                {cardRemaining.frequencyTotal}
                {` (${Math.round(cardRemaining.frequencyPercentage * 100)}%)`}
              </TableCardValue>
            </ContainerRow>
          ))}
        </>
      )}
    </ContainerColumn>
  );
};

CardsList.propTypes = {
  group: PropTypes.arrayOf(PropTypes.shape({
    cardSortCategory: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    frequencyTotal: PropTypes.number,
    frequencyPercentage: PropTypes.number,
  })).isRequired,
};

export default CardsList;
